/*
 * @Descripttion: 
 * @Author: huxianglong
 * @Date: 2023-05-03 11:21:54
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-05-03 11:30:03
 */
import type { App } from "vue";
import isPromise from "./isPromise";
import { ElLoading } from 'element-plus'

export function setDirective(app: App<Element>) {
  app.directive('isPromise', isPromise)
  app.directive('loading', ElLoading.directive)
}